import { Navigate, Outlet } from "react-router-dom";
import React, { useEffect } from "react";
import Dashboard from "../Pages/Dashboard";

const ProtectedRoutes = () => {
  const useAuth = () => {
    if (sessionStorage.getItem("usuario")) {
      return 1;
    }
  };

  // aqui se ejectura useAuth al arrancar el
  const isAuth = useAuth();

  // puedes retornar el mismo componente pero ocultas los modulos correspondientes

  if (isAuth === 1) {
    return <Dashboard />;
  }

  return <Navigate to="/" />;
};

export default ProtectedRoutes;
